'use strict';

var GridToolbarUserManagementRoleManagementDirective = function GridToolbarUserManagementRoleManagementDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-user-management-role-management.html')
  };
};
GridToolbarUserManagementRoleManagementDirective.$inject = [];
module.exports = GridToolbarUserManagementRoleManagementDirective;